(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tl-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tl-faq][data-tl-faq-close-others]').forEach((section) => {
    section.querySelectorAll('details.tl-faq__item').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;

        section.querySelectorAll('details.tl-faq__item').forEach((item) => {
          if (item !== details) item.open = false;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
